<asax-frequency-view-frequency-view-chart-splat-popover [splat]="splat | async">
</asax-frequency-view-frequency-view-chart-splat-popover>
